module.exports = __webpack_public_path__ + "img/icon_tequan.fe721093.svg";